import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AskValue from "../global/BidAsk/AskValue";
import BidValue from "../global/BidAsk/BidValue";
import SpreadValue from "../global/BidAsk/SpreadValue";
import WatlistArrow from "../global/BidAsk/WatlistArrow";
import High from "../global/BidAsk/High";
import Low from "../global/BidAsk/Low";
import DailyChange from "../global/BidAsk/DailyChange";
import PercentageChange from "../global/BidAsk/PercentageChange";
import BidBuy from "../global/BidAsk/BidBuy";
import AskSell from "../global/BidAsk/AskSell";

const defaultRender = (value) => (value ? value : "--");

const SymbolCell = () => {
  const { t } = useTranslation();
  const allSymbolParams = useSelector((state) => state.symbol.allSymbolParams);

  const columns = React.useMemo(() => ([
    {
      title: t("symbol"), width: 200, dataIndex: "name", render: (value, row) => {
        return <div className="flex items-center justify-start" style={{ width: 500 }}>
          <WatlistArrow symbolId={row.id}></WatlistArrow>
          {row?.name}
        </div>
      },
    },
    // { title: t("bid"), width: 100, dataIndex: "bid", render: (value, row) => (value ? <BidValue symbolId={row.id} digits={row?.digits} /> : "--") },
    { title: t("bid"), width: 140, dataIndex: "bid", render: (value, row) => (value ? <BidBuy symbolId={row.id} digits={row?.digits} /> : "--") },
    // { title: t("ask"), width: 150, dataIndex: "ask", render: (value, row) => (value ? <AskValue symbolId={row.id} digits={row?.digits} /> : "--") },
    { title: t("ask"), width: 140, dataIndex: "ask", render: (value, row) => (value ? <AskSell symbolId={row.id} digits={row?.digits} /> : "--") },
    {
      title: t("spread"), width: 100, dataIndex: "spread",
      render: (_, row) => <SpreadValue symbolId={row.id} />
    },
    {
      title: t("dailyChange"), width: 100, dataIndex: "dailyChange",
      render: (_, row) => <DailyChange symbolId={row.id} digits={row.digits} />
    },
    {
      title: t("percentage"), width: 100, dataIndex: "percentage",
      render: (_, row) => <PercentageChange symbolId={row.id} />
    },
    {
      title: t("time"), width: 100, dataIndex: "lastQuoteTime",
      render: (value) => {
        if (value) {
          const time = new Date(value).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
          return time;
        }
        return defaultRender(value);
      }
    },
    { title: t("askHigh"), width: 100, dataIndex: "high", render: (value, row) => (value ? <High symbolId={row.id} digits={row?.digits}/> : "--") },
    { title: t("askLow"), width: 100, dataIndex: "low", render: (value, row) => (value ? <Low symbolId={row.id} digits={row?.digits}/> : "--") },
    { title: t("openPrice"), width: 100, dataIndex: "open", render: (value, row) => (value ? value.toFixed(row.digits) : "--") },
    { title: t("closePrice"), width: 100, dataIndex: "close", render: (value, row) => (value ? value.toFixed(row.digits) : "--") },
    { title: t("last"), width: 100, dataIndex: "last", render: (value, row) => (value ? value.toFixed(row.digits) : "--") },
    { title: t("lastHigh"), width: 100, dataIndex: "lasthigh", render: (value, row) => (value ? value.toFixed(row.digits) : "--") },
    { title: t("lastLow"), width: 100, dataIndex: "lastlow", render: (value, row) => (value ? value.toFixed(row.digits) : "--") },
  ]), [allSymbolParams])

  return columns;
};

export default SymbolCell;
